import { render, staticRenderFns } from "./DreamBooks.vue?vue&type=template&id=7a1cc2f9&scoped=true"
import script from "./DreamBooks.vue?vue&type=script&lang=js"
export * from "./DreamBooks.vue?vue&type=script&lang=js"
import style0 from "./DreamBooks.vue?vue&type=style&index=0&id=7a1cc2f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1cc2f9",
  null
  
)

export default component.exports